<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Summary Report PO</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Type</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-select outlined dense hide-details="auto" :items="typeReport" item-value="code" item-text="name" v-model="selectedType" class="compact-form" @change="handleChangeType"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Start Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="start_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" @change="handelChangeStartDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedSize" class="compact-form" @change="handleChangeVolume"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">End Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="end_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="end_date" @change="handelChangeEndDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">{{ selectedTypeReport.name }}</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="typeFilters" item-value="code" item-text="name" v-model="selectedFilter" class="compact-form" @change="handleChangeTypeFilter"></v-select>
                    </v-col>
                </v-row>
                <v-row class="compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-skeleton-loader v-if="isLoading"
                                v-bind="attrs"
                                type="table-tbody">
                            </v-skeleton-loader>
                            <v-simple-table v-else fixed-header height="400" ref="tabelExport">
                                <template v-slot:default class="spreedsheet-tablex">
                                    <thead>
                                        <tr>
                                            <th class="header-cell text-center" colspan="3">{{ selectedSize }}ML</th>
                                            <th class="header-cell text-center" v-for="(head, idh) in headers" :key="idh">
                                                {{ head.day_name }}
                                            </th>
                                            <th class="header-cell text-center">TOTAL</th>
                                        </tr>
                                        <tr>
                                            <th class="header-cell" style="width:5px;">NO.</th>
                                            <th class="header-cell text-center">KODE</th>
                                            <th class="header-cell text-center">PRODUK ({{ selectedSize }} ML)</th>
                                            <th class="header-cell text-center" v-for="(head, idh) in headers" :key="idh">
                                                {{ head.date }}
                                            </th>
                                            <th class="header-cell text-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, idx) in items" :key="idx">
                                            <td>{{ idx + 1 }}</td>
                                            <td class="text-no-wrap">{{ item.product_code }}</td>
                                            <td class="text-no-wrap">{{ item.product_name }}</td>
                                            <td class="text-center" v-for="(day, idd) in item.days" :key="idd">
                                                {{ day.qty }}
                                            </td>
                                            <td class="text-center">{{ item.total }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th class="header-cell text-center" colspan="3">GRAND TOTAL</th>
                                            <th class="text-center" v-for="(qty, day) in totalPerDay" :key="day">{{ qty }}</th>
                                            <th class="text-center">{{ grandTotal }}</th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            start_date: '',
            startDateMenu: false,
            end_date: '',
            endDateMenu: false,
            headers: [],
            items: [],
            selectedSize: '490',
            isLoading: false,
            bottles: [],
            selectedOperasional: '',
            selectedKoordinator: '',
            selectedOutlet: '',
            operational_teams: [],
            coordinators: [],
            outlets: [],
            selectedType: 'operational',
            selectedFilter: '',
            typeReport: [
                { code: 'operational', name: 'Operational' },
                { code: 'coordinator', name: 'Coordinator' },
                { code: 'outlet', name: 'Outlet' },
            ],
        }
    },

    async created() {
        this.getBottles();
        
        this.operational_teams = (await this.$store.dispatch('getObjs', {apidomain: 'users', parameter: ''})).data.data
        this.operational_teams = this.operational_teams.filter(user => user.group == 'OP')

        this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data;
        this.outlets = (await this.$store.dispatch('outlet/getObjs')).data.data;

        this.fetchData();
    },

    computed: {
        totalPerDay() {
            const result = {};

            this.items.forEach(item => {
                item.days.forEach(day => {
                    if (!result[day.day]) result[day.day] = 0;
                    result[day.day] += day.qty;
                });
            });

            return result;
        },
        grandTotal() {
            let total = 0;
            this.items.forEach(item => {
                item.days.forEach(day => {
                    total += day.qty;
                });
            });

            return total;
        },
        selectedTypeReport() {
            return this.typeReport.find(item => item.code === this.selectedType);
        },
        typeFilters() {
            let result = [];

            if (this.selectedType == 'operational') {
                result.push({ code: '', name: 'All Operational'});
                if (this.operational_teams.length > 0) {
                    this.operational_teams.forEach(item => {
                        result.push({code: item.username, name: item.fullname });
                    });
                }
            } else if (this.selectedType == 'coordinator') {
                result.push({ code: '', name: 'All Coordinator'});
                if (this.coordinators.length > 0) {
                    this.coordinators.forEach(item => {
                        result.push(item);
                    });
                }
            } else if (this.selectedType == 'outlet') {
                result.push({ code: '', name: 'All Outlet'});
                if (this.outlets.length > 0) {
                    this.outlets.forEach(item => {
                        result.push({ code: item.code, name: item.name});
                    });
                }
            }

            return result;
        }
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        handelChangeStartDate() {
            this.fetchData();
        },
        handelChangeEndDate() {
            this.fetchData();
        },
        handleChangeType() {
            this.fetchData();
        },
        handleChangeTypeFilter() {
            this.fetchData();
        },
        handleChangeVolume() {
            this.fetchData();
        },
        async fetchData() {
            this.isLoading = true;

            try {
                const response = (await this.$store.dispatch('getObjs', {
                    apidomain: `report-po`,
                    parameter: `?type=${this.selectedType}&type_val=${this.selectedFilter}&start_date=${this.start_date}&end_date=${this.end_date}&size=${this.selectedSize}`,
                }));

                const data = response.data.data;
                console.log(data);

                this.start_date = data.start_date;
                this.end_date = data.end_date;
                this.headers = data.headers;
                this.items = data.items;
            } catch (error) {
                console.log('Error fetching report po : ', error);
            } finally {
                this.isLoading = false;
            }
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            let fileName = 'Summary-Report-PO.xlsx';

            writeFileXLSX(wb, fileName);
        },
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>